// Greenline marketing site — shared imagery, copy, and helpers.
// Swap real project photos in here when they arrive — every other
// file pulls from this single source of truth.

const UNSPLASH = (id, w = 2400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=85`;

// Hero image — a world-class kitchen (matches Greenline's craft).
export const HERO_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/d2574768-c6b6-47d1-b3f5-5365e206636a/images/39689cc69ea061076d2a0d925b19c2b19f28b6918c50b2be2cac67ca41eba348.png';

export const KITCHEN_IMAGES = [
  { src: 'https://static.prod-images.emergentagent.com/jobs/d2574768-c6b6-47d1-b3f5-5365e206636a/images/ab88823e138e586992b5de237527c822f6f3d5363d210f61fd82499f616f9aa9.png', title: 'Sage Kitchen Renovation', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1628745277862-bc0b2d68c50c'), title: 'Kitchen Project Two', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1683629357963-adf2b1fa9ad9'), title: 'Kitchen Project Three', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1682888813913-e13f18692019'), title: 'Kitchen Project Four', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1631048501619-a27088a3bb70'), title: 'Kitchen Project Five', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1611095210561-67f0832b1ca3'), title: 'Kitchen Project Six', city: 'Massachusetts' },
];

export const BATHROOM_IMAGES = [
  { src: 'https://customer-assets.emergentagent.com/job_d2574768-c6b6-47d1-b3f5-5365e206636a/artifacts/wrdbnxs7_8e6d04f3-d3e7-4e36-a7c7-64b4691b0224%20%281%29.JPG', title: 'Marble Bath Renovation', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1564540583246-934409427776'), title: 'Bathroom Project Two', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1620626011761-996317b8d101'), title: 'Bathroom Project Three', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1771929662486-f793e08f0f16'), title: 'Bathroom Project Four', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1760546120487-ccb54df9838c'), title: 'Bathroom Project Five', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1668911094844-527491335108'), title: 'Bathroom Project Six', city: 'Massachusetts' },
];

export const CARPENTRY_IMAGES = [
  { src: 'https://static.prod-images.emergentagent.com/jobs/d2574768-c6b6-47d1-b3f5-5365e206636a/images/d9a7d4ef76c3f3ea3a198e37c8451ca1db5324c333ac3d062b9c5b0d0a2f0bbc.png', title: 'Completed Deck', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1640357154220-9775b0f31dec'), title: 'Custom Closet', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1581858726788-75bc0f6a952d'), title: 'Fireplace Mantel', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1604578762246-41134e37f9cc'), title: 'Stair Railing', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1768527341242-62055b63260b'), title: 'Custom Deck', city: 'Massachusetts' },
];

export const BASEMENT_IMAGES = [
  { src: UNSPLASH('photo-1593696140826-c58b021acf8b'), title: 'Finished Basement', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1638369022547-1c763b1b9b3b'), title: 'Basement Living Room', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1628745750131-e5cfc5e70ced'), title: 'Media Lounge', city: 'Massachusetts' },
  { src: UNSPLASH('photo-1704040686433-b1c45e9f4104'), title: 'Family Room', city: 'Massachusetts' },
];

// Real Greenline project photos (remastered for clarity)
const REAL = {
  kitchenBefore: 'https://static.prod-images.emergentagent.com/jobs/d2574768-c6b6-47d1-b3f5-5365e206636a/images/e2f9264bcb466ce132d551d746e5936876c3b7201f72b1b31343ad695fdc4a1b.png',
  kitchenAfter: 'https://static.prod-images.emergentagent.com/jobs/d2574768-c6b6-47d1-b3f5-5365e206636a/images/ab88823e138e586992b5de237527c822f6f3d5363d210f61fd82499f616f9aa9.png',
  bathBefore: 'https://customer-assets.emergentagent.com/job_d2574768-c6b6-47d1-b3f5-5365e206636a/artifacts/fxg90zn6_d378576c-d2b2-475d-bbcb-219461d2cd48.JPG',
  bathAfter: 'https://customer-assets.emergentagent.com/job_d2574768-c6b6-47d1-b3f5-5365e206636a/artifacts/wrdbnxs7_8e6d04f3-d3e7-4e36-a7c7-64b4691b0224%20%281%29.JPG',
};

export const COMPARES = [
  {
    // Real Greenline bathroom: dated tile bath -> renovated marble bath
    before: REAL.bathBefore,
    after: REAL.bathAfter,
    title: 'Spa Bath Reveal',
  },
  {
    // Real Greenline kitchen: dated oak kitchen -> renovated sage-green kitchen
    before: REAL.kitchenBefore,
    after: REAL.kitchenAfter,
    title: 'Kitchen Reveal',
  },
];

export const TRUST_STATS = [
  { value: 'BBB', label: 'A-Rated Accredited Business' },
  { value: 'HIC #218099', label: 'Licensed in Massachusetts' },
  { value: '5-Year', label: 'Workmanship Warranty' },
  { value: 'Eastern MA', label: 'Serving Greater Boston' },
];

// Interactive hero hotspots (positioned over the cinematic background)
export const HERO_HOTSPOTS = [
  { to: '/kitchens', label: 'Kitchens', detail: 'Custom cabinetry & marble islands', x: '23%', y: '74%' },
  { to: '/bathrooms', label: 'Bathrooms', detail: 'Spa showers & natural stone', x: '49%', y: '40%' },
  { to: '/basements', label: 'Basements', detail: 'Finished living spaces', x: '70%', y: '80%' },
  { to: '/carpentry', label: 'Carpentry', detail: 'Built-ins, trim & decks', x: '88%', y: '52%' },
];

// Scroll-revealed transformation timeline
const PROD = (id) => `https://static.prod-images.emergentagent.com/jobs/d2574768-c6b6-47d1-b3f5-5365e206636a/images/${id}.png`;
export const TRANSFORM_STAGES = [
  { step: '01', title: 'Before', img: PROD('e2f9264bcb466ce132d551d746e5936876c3b7201f72b1b31343ad695fdc4a1b'), text: 'A dated, closed-off kitchen with untapped potential.' },
  { step: '02', title: 'Demolition', img: PROD('43038b2d5f87c8a1db9d868ab349680c7359320b7c707f637301cba71178042b'), text: 'Careful tear-out down to the studs — clean and contained.' },
  { step: '03', title: 'Framing & Systems', img: UNSPLASH('photo-1768321903836-de712f966a25'), text: 'New layout framed; electrical, plumbing, and structure dialed in.' },
  { step: '04', title: 'Finish Carpentry', img: PROD('b3e8b66ec76c2d57cc9c0ff84467c6d0e51606feb359870ace9aa6688a43c052'), text: 'Custom cabinetry and trim installed with precision.' },
  { step: '05', title: 'Completed', img: PROD('ab88823e138e586992b5de237527c822f6f3d5363d210f61fd82499f616f9aa9'), text: 'A bright, open, heirloom kitchen built to last.' },
];

export const PROCESS_STEPS = [
  { step: '01', title: 'Consultation', body: "A no-pressure visit. We walk the space, listen to how you live, and outline what is — and isn't — possible." },
  { step: '02', title: 'Design', body: 'Renderings, materials, and a transparent line-itemed proposal. No upcharges, no surprises.' },
  { step: '03', title: 'Build', body: 'In-house carpenters. Same project lead every day. Clean job sites, end-of-day photo updates.' },
  { step: '04', title: 'Reveal', body: 'Final walkthrough, punch-list closure, and your 5-year written warranty.' },
];

export const TESTIMONIALS = [
  {
    quote: 'They treated our 1890 home like a museum piece. Every casing matched, every grain ran the right way. Worth every dollar.',
    name: 'A. Hartley',
    project: 'Beacon Hill Whole-Home',
  },
  {
    quote: "I've worked with three contractors in twenty years. Greenline is the only one I'd hand the keys to without thinking.",
    name: 'M. & R. Cohen',
    project: 'Wellesley Primary Suite',
  },
];

export const COMPANY = {
  name: 'Greenline Construction',
  tagline: 'Built Quietly. Finished Beautifully.',
  logo: 'https://customer-assets.emergentagent.com/job_d2574768-c6b6-47d1-b3f5-5365e206636a/artifacts/b1dyhzx4_greenline-logo.png',
  phone: '(781) 288-4030',
  phoneHref: 'tel:+17812884030',
  email: 'info@gogreenline.org',
  emailHref: 'mailto:info@gogreenline.org',
  address: 'Serving Eastern Massachusetts',
  social: {
    instagram: 'https://instagram.com/gogreenline',
    houzz: 'https://houzz.com/pro/gogreenline',
  },
};
